import {AgentView, SiteJumpAgentInfo, useUserInfo} from '@ozark/common';
import {getAgents} from '@ozark/common/firebase/queries/agents';
import {getChildAgentsByUid} from '@ozark/common/hooks/useAgents';
import {uniqBy} from '@s-libs/micro-dash';
import {useEffect, useState} from 'react';
import {useStore} from '../store/helpers';

const emptyArray: SiteJumpAgentInfo[] = [];

const agentViewToSiteJumpAgentInfo = (agentView: AgentView): SiteJumpAgentInfo => ({
  id: agentView.id,
  fullName: [agentView.firstName, agentView.lastName].filter(Boolean).join(' ').trim() ?? '-',
  groupName: agentView.group?.name ?? '-',
});

const useSiteJumpAgents = () => {
  const {isAgentAdmin, isAgentMember, uid, userGroupId} = useUserInfo();
  const {authProfile} = useStore();

  const [result, setResult] = useState<SiteJumpAgentInfo[]>(emptyArray);

  useEffect(() => {
    if (!userGroupId || !uid) {
      return;
    }

    if (isAgentMember) {
      getChildAgentsByUid(uid)
        .then(agentViews => {
          const agents = agentViews.filter(x => !x.deleted).map(agentViewToSiteJumpAgentInfo);

          const existingAgents: SiteJumpAgentInfo[] = authProfile.data?.siteJumpAgents || [];

          setResult(uniqBy([...existingAgents, ...agents], x => x.id));
        })
        .catch(err => {
          console.error('Could not get agents to site jump', err);
        });
    } else if (isAgentAdmin) {
      getAgents({activeOnly: true, groupId: userGroupId})
        .then(agentViews => {
          const agents = agentViews.filter(x => !x.deleted).map(agentViewToSiteJumpAgentInfo);

          const existingAgents: SiteJumpAgentInfo[] = authProfile.data?.siteJumpAgents || [];

          setResult(uniqBy([...existingAgents, ...agents], x => x.id));
        })
        .catch(err => {
          console.error('Could not get agents to site jump', err);
        });
    }
  }, [authProfile.data?.siteJumpAgents, isAgentAdmin, isAgentMember, uid, userGroupId]);

  return result;
};

export {useSiteJumpAgents};
